module.exports = __webpack_public_path__ + "static/media/0eb1300b.jpg";